// Executive mini row — SMS Inbox + Live Chat at-a-glance with deep links.
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { MessageSquare, MessagesSquare } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Mini = ({ to, icon: Icon, title, big, sub, testId }) => (
  <Link to={to} data-testid={testId}
    className="rounded-xl border border-slate-200 bg-white shadow-sm px-5 py-4 flex items-center gap-4 hover:border-teal-300 transition-colors">
    <div className="w-10 h-10 rounded-xl bg-teal-50 text-teal-600 flex items-center justify-center"><Icon className="w-5 h-5" /></div>
    <div>
      <p className="text-[11px] uppercase tracking-wide text-slate-400 font-semibold">{title}</p>
      <p className="text-lg font-bold text-slate-800">{big}</p>
      <p className="text-[11px] text-slate-500">{sub}</p>
    </div>
  </Link>
);

export const ExecCommsMiniRow = () => {
  const [sms, setSms] = useState(null);
  const [chat, setChat] = useState(null);
  useEffect(() => {
    axios.get(`${API}/sms/replies`, { params: { days: 7 } })
      .then((r) => {
        const rows = r.data.replies || r.data.items || [];
        setSms({ total: rows.length, open: r.data.unanswered ?? rows.filter((x) => !x.answered).length });
      }).catch(() => {});
    axios.get(`${API}/livechat/analytics`).then((r) => setChat(r.data)).catch(() => {});
  }, []);
  if (!sms && !chat) return null;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="exec-comms-row">
      {sms && (
        <Mini to="/sms-inbox" icon={MessageSquare} title="SMS Inbox" testId="exec-sms-mini"
          big={`${sms.open} awaiting reply`} sub={`${sms.total} replies in the last 7 days — open the inbox`} />
      )}
      {chat && (
        <Mini to="/livechat" icon={MessagesSquare} title="Live Chat" testId="exec-chat-mini"
          big={`${chat.open_now ?? 0} open now`}
          sub={`${chat.total_chats ?? 0} chats · ${chat.ai_resolved ?? 0} AI resolved · ${chat.human_handled ?? 0} human — open live chat`} />
      )}
    </div>
  );
};

export default ExecCommsMiniRow;
